module.exports = __webpack_public_path__ + "img/payment-waiting-dana.987c03e7.png";